if (process && process.env && process.env.NODE_ENV !== 'production') {
    console.log(
        '%c Running Dev build: chunk.serach-filter-experience',
        'background:red; color:white; font-size:16px;'
    );
}

const SearchPage = () => {};

export default SearchPage;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/search-results/search-filter-experience.js